import { g as getAugmentedNamespace } from './_commonjsHelpers-11ca3be1.js';

const _nodeResolve_empty = {};

const _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': _nodeResolve_empty
});

const require$$2 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

export { require$$2 as r };
